// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3joZl","footer":"ModalFilter_footer__wgB5w"};